import Box from "@material-ui/core/Box";

const box = ({ children, ...otherProps }) => {
  return <Box {...otherProps}>{children}</Box>;
};

export default box